import { ShipInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import { useLengthUnits } from '../../Units/useLengthUnits';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface VesselInfoTooltipProps {
  vesselInfo: ShipInfo;
}

export const VesselInfoTooltip = ({ vesselInfo }: VesselInfoTooltipProps) => {
  const { settings } = useSettings();
  const { convertLengthString } = useLengthUnits();
  const ribbonSettings = settings['ribbonPlugin.settings'];

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'aisType',
      label: 'AIS',
      value: vesselInfo.aisType,
      visible: ribbonSettings?.show_vessel_ais_type,
    },
    {
      key: 'imo',
      label: 'IMO',
      value: vesselInfo.imo,
      visible: ribbonSettings?.show_vessel_imo,
    },
    {
      key: 'mmsi',
      label: 'MMSI',
      value: vesselInfo.mmsi,
      visible: ribbonSettings?.show_vessel_mmsi,
    },
    {
      key: 'callsign',
      label: 'Callsign',
      value: vesselInfo.callSign,
      visible: ribbonSettings?.show_vessel_callsign,
    },
    {
      key: 'shipType',
      label: 'Vessel type',
      value: vesselInfo.shipType,
      visible: ribbonSettings?.show_vessel_shiptype,
    },
    {
      key: 'cargoType',
      label: 'Cargo type',
      value: vesselInfo.cargoType,
      visible: ribbonSettings?.show_vessel_cargotype,
    },
    {
      key: 'country',
      label: 'Country',
      value: vesselInfo.country,
      visible: ribbonSettings?.show_vessel_country,
    },
    {
      key: 'destination',
      label: 'Destination',
      value: vesselInfo.destination,
      visible: ribbonSettings?.show_vessel_destination,
    },
    {
      key: 'width',
      label: 'Width',
      value: vesselInfo.width
        ? convertLengthString(vesselInfo.width)
        : undefined,
      visible: ribbonSettings?.show_vessel_size,
    },
    {
      key: 'length',
      label: 'Length',
      value: vesselInfo.length
        ? convertLengthString(vesselInfo.length)
        : undefined,
      visible: ribbonSettings?.show_vessel_size,
    },
    {
      key: 'sog',
      label: 'SOG',
      value: vesselInfo.speedOverGround,
      visible: ribbonSettings?.show_vessel_sog,
    },
    {
      key: 'cog',
      label: 'COG',
      value: vesselInfo.courseOverGround,
      visible: ribbonSettings?.show_vessel_cog,
    },
    {
      key: 'heading',
      label: 'Heading',
      value: vesselInfo.heading,
      visible: ribbonSettings?.show_vessel_heading,
    },
    {
      key: 'draught',
      label: 'Draught',
      value: vesselInfo.draught
        ? convertLengthString(vesselInfo.draught)
        : undefined,
      visible: ribbonSettings?.show_vessel_draught,
    },
    {
      key: 'navStatus',
      label: 'Navigational status',
      value: vesselInfo.navigationalStatus,
      visible: ribbonSettings?.show_vessel_navstatus,
    },
  ];

  return <InfoTooltipFields fields={fields} />;
};
